import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { Library, FileAttachments } from "@observablehq/stdlib";
import { RuntimeError } from "./errors";
import generatorish from "./generatorish";
import load from "./load";
import Module from "./module";
import noop from "./noop";
import Variable, { TYPE_IMPLICIT, no_observer } from "./variable";
var frame = typeof requestAnimationFrame === "function" ? requestAnimationFrame : setImmediate;
export var variable_invalidation = {};
export var variable_visibility = {};
export default function Runtime() {
  var builtins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Library();
  var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window_global;
  var builtin = this.module();
  Object.defineProperties(this, {
    _dirty: {
      value: new Set()
    },
    _updates: {
      value: new Set()
    },
    _computing: {
      value: null,
      writable: true
    },
    _init: {
      value: null,
      writable: true
    },
    _modules: {
      value: new Map()
    },
    _variables: {
      value: new Set()
    },
    _disposed: {
      value: false,
      writable: true
    },
    _builtin: {
      value: builtin
    },
    _global: {
      value: global
    }
  });
  if (builtins) for (var name in builtins) {
    new Variable(TYPE_IMPLICIT, builtin).define(name, [], builtins[name]);
  }
}
Object.defineProperties(Runtime, {
  load: {
    value: load,
    writable: true,
    configurable: true
  }
});
Object.defineProperties(Runtime.prototype, {
  _compute: {
    value: runtime_compute,
    writable: true,
    configurable: true
  },
  _computeSoon: {
    value: runtime_computeSoon,
    writable: true,
    configurable: true
  },
  _computeNow: {
    value: runtime_computeNow,
    writable: true,
    configurable: true
  },
  dispose: {
    value: runtime_dispose,
    writable: true,
    configurable: true
  },
  module: {
    value: runtime_module,
    writable: true,
    configurable: true
  },
  fileAttachments: {
    value: FileAttachments,
    writable: true,
    configurable: true
  }
});

function runtime_dispose() {
  this._computing = Promise.resolve();
  this._disposed = true;

  this._variables.forEach(function (v) {
    v._invalidate();

    v._version = NaN;
  });
}

function runtime_module(define) {
  var observer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
  var module;

  if (define === undefined) {
    if (module = this._init) {
      this._init = null;
      return module;
    }

    return new Module(this);
  }

  module = this._modules.get(define);
  if (module) return module;
  this._init = module = new Module(this);

  this._modules.set(define, module);

  try {
    define(this, observer);
  } finally {
    this._init = null;
  }

  return module;
}

function runtime_compute() {
  return this._computing || (this._computing = this._computeSoon());
}

function runtime_computeSoon() {
  var runtime = this;
  return new Promise(function (resolve) {
    frame(function () {
      resolve();
      runtime._disposed || runtime._computeNow();
    });
  });
}

function runtime_computeNow() {
  var queue = [],
      variables,
      variable; // Compute the reachability of the transitive closure of dirty variables.
  // Any newly-reachable variable must also be recomputed.
  // Any no-longer-reachable variable must be terminated.

  variables = new Set(this._dirty);
  variables.forEach(function (variable) {
    variable._inputs.forEach(variables.add, variables);

    var reachable = variable_reachable(variable);

    if (reachable > variable._reachable) {
      this._updates.add(variable);
    } else if (reachable < variable._reachable) {
      variable._invalidate();
    }

    variable._reachable = reachable;
  }, this); // Compute the transitive closure of updating, reachable variables.

  variables = new Set(this._updates);
  variables.forEach(function (variable) {
    if (variable._reachable) {
      variable._indegree = 0;

      variable._outputs.forEach(variables.add, variables);
    } else {
      variable._indegree = NaN;
      variables.delete(variable);
    }
  });
  this._computing = null;

  this._updates.clear();

  this._dirty.clear(); // Compute the indegree of updating variables.


  variables.forEach(function (variable) {
    variable._outputs.forEach(variable_increment);
  });

  do {
    // Identify the root variables (those with no updating inputs).
    variables.forEach(function (variable) {
      if (variable._indegree === 0) {
        queue.push(variable);
      }
    }); // Compute the variables in topological order.

    while (variable = queue.pop()) {
      variable_compute(variable);

      variable._outputs.forEach(postqueue);

      variables.delete(variable);
    } // Any remaining variables are circular, or depend on them.


    variables.forEach(function (variable) {
      if (variable_circular(variable)) {
        variable_error(variable, new RuntimeError("circular definition"));

        variable._outputs.forEach(variable_decrement);

        variables.delete(variable);
      }
    });
  } while (variables.size);

  function postqueue(variable) {
    if (--variable._indegree === 0) {
      queue.push(variable);
    }
  }
}

function variable_circular(variable) {
  var inputs = new Set(variable._inputs);

  var _iterator = _createForOfIteratorHelper(inputs),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var i = _step.value;
      if (i === variable) return true;

      i._inputs.forEach(inputs.add, inputs);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return false;
}

function variable_increment(variable) {
  ++variable._indegree;
}

function variable_decrement(variable) {
  --variable._indegree;
}

function variable_value(variable) {
  return variable._promise.catch(variable._rejector);
}

function variable_invalidator(variable) {
  return new Promise(function (resolve) {
    variable._invalidate = resolve;
  });
}

function variable_intersector(invalidation, variable) {
  var node = typeof IntersectionObserver === "function" && variable._observer && variable._observer._node;
  var visible = !node,
      resolve = noop,
      reject = noop,
      promise,
      observer;

  if (node) {
    observer = new IntersectionObserver(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          entry = _ref2[0];

      return (visible = entry.isIntersecting) && (promise = null, resolve());
    });
    observer.observe(node);
    invalidation.then(function () {
      return observer.disconnect(), observer = null, reject();
    });
  }

  return function (value) {
    if (visible) return Promise.resolve(value);
    if (!observer) return Promise.reject();
    if (!promise) promise = new Promise(function (y, n) {
      return resolve = y, reject = n;
    });
    return promise.then(function () {
      return value;
    });
  };
}

function variable_compute(variable) {
  variable._invalidate();

  variable._invalidate = noop;

  variable._pending();

  var value0 = variable._value,
      version = ++variable._version,
      invalidation = null,
      promise = variable._promise = Promise.all(variable._inputs.map(variable_value)).then(function (inputs) {
    if (variable._version !== version) return; // Replace any reference to invalidation with the promise, lazily.

    for (var i = 0, n = inputs.length; i < n; ++i) {
      switch (inputs[i]) {
        case variable_invalidation:
          {
            inputs[i] = invalidation = variable_invalidator(variable);
            break;
          }

        case variable_visibility:
          {
            if (!invalidation) invalidation = variable_invalidator(variable);
            inputs[i] = variable_intersector(invalidation, variable);
            break;
          }
      }
    } // Compute the initial value of the variable.


    return variable._definition.apply(value0, inputs);
  }).then(function (value) {
    // If the value is a generator, then retrieve its first value,
    // and dispose of the generator if the variable is invalidated.
    // Note that the cell may already have been invalidated here,
    // in which case we need to terminate the generator immediately!
    if (generatorish(value)) {
      if (variable._version !== version) return void value.return();
      (invalidation || variable_invalidator(variable)).then(variable_return(value));
      return variable_precompute(variable, version, promise, value);
    }

    return value;
  });
  promise.then(function (value) {
    if (variable._version !== version) return;
    variable._value = value;

    variable._fulfilled(value);
  }, function (error) {
    if (variable._version !== version) return;
    variable._value = undefined;

    variable._rejected(error);
  });
}

function variable_precompute(variable, version, promise, generator) {
  function recompute() {
    var promise = new Promise(function (resolve) {
      resolve(generator.next());
    }).then(function (next) {
      return next.done ? undefined : Promise.resolve(next.value).then(function (value) {
        if (variable._version !== version) return;
        variable_postrecompute(variable, value, promise).then(recompute);

        variable._fulfilled(value);

        return value;
      });
    });
    promise.catch(function (error) {
      if (variable._version !== version) return;
      variable_postrecompute(variable, undefined, promise);

      variable._rejected(error);
    });
  }

  return new Promise(function (resolve) {
    resolve(generator.next());
  }).then(function (next) {
    if (next.done) return;
    promise.then(recompute);
    return next.value;
  });
}

function variable_postrecompute(variable, value, promise) {
  var runtime = variable._module._runtime;
  variable._value = value;
  variable._promise = promise;

  variable._outputs.forEach(runtime._updates.add, runtime._updates); // TODO Cleaner?


  return runtime._compute();
}

function variable_error(variable, error) {
  variable._invalidate();

  variable._invalidate = noop;

  variable._pending();

  ++variable._version;
  variable._indegree = NaN;
  (variable._promise = Promise.reject(error)).catch(noop);
  variable._value = undefined;

  variable._rejected(error);
}

function variable_return(generator) {
  return function () {
    generator.return();
  };
}

function variable_reachable(variable) {
  if (variable._observer !== no_observer) return true; // Directly reachable.

  var outputs = new Set(variable._outputs);

  var _iterator2 = _createForOfIteratorHelper(outputs),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var output = _step2.value;
      if (output._observer !== no_observer) return true;

      output._outputs.forEach(outputs.add, outputs);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return false;
}

function window_global(name) {
  return window[name];
}